import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filesize'
})
export class FilesizePipe implements PipeTransform {

  transform(value: number): string {
    if (value < 1024) {
      return value + ' B';
    } else if (value < 1024 * 1024) {
      return (value / 1024).toFixed(2) + ' KB';
    } else if (value < 1024 * 1024 * 1024) {
      return (value / (1024 * 1024)).toFixed(2) + ' MB';
    } else if (value < 1024 * 1024 * 1024 * 1024) {
      return (value / (1024 * 1024 * 1024)).toFixed(2) + ' GB';
    } else {
      return (value / (1024 * 1024 * 1024 * 1024)).toFixed(2) + ' TB';
    }
  }

}
